import { Grid } from "@mui/material";
import React from "react";
import ProductsOrdersHeader from "./home/header";
import ProductsOrdersTable from "./home/table";


const ProductsOrders = () => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <ProductsOrdersHeader />
      </Grid>
      <Grid item xs={12}>
        <ProductsOrdersTable />
      </Grid>
    </Grid>
  );
};

export default ProductsOrders;
